import React from 'react';
import { dummyClick } from '../utilities';
import DropdownMenu from '../../design/DropdownMenu';
import MobileCarret from './MobileCarret';
import MobileIcon from './MobileIcon';

const EpisodesDropdown = ({ onClick, readerLabel, storyUrl, storyTitle, episodeTitle, opened, children }) => (
  <div className="left relative a-header-line-height">
    <MobileIcon onClick={onClick} />
    <MobileCarret onClick={onClick} />
    <div className="xs-hide sm-hide">
      <span className="mr4 lg-pr2 align-middle"> {readerLabel} </span>
      <a className="text-decoration-none white inline-block align-middle a-current-story-title cursor-pointer"
        href={storyUrl}
      title="Story title">
        {storyTitle}
      </a>
      <span className="inline-block align-middle mx1">/</span>
      <span id="episodes-toggles">
        <span className="inline-block align-middle a-current-episode-title mr1 cursor-pointer" onClick={onClick}>
          {episodeTitle}
        </span>
        <span className="a-caret-sprite cursor-pointer" onClick={onClick}></span>
      </span>
    </div>
    <DropdownMenu width='272px' className="a-ddm-position" opened={opened}>{children}</DropdownMenu>
  </div>
);

EpisodesDropdown.defaultProps = {
  onClick: dummyClick,
  opened: false,
  readerLabel: 'EN readerLabel',
  storyUrl: 'EN storyUrl',
  storyTitle: 'EN storyTitle',
  episodeTitle: 'EN episodeTitle'
};

export default EpisodesDropdown;
